import { BuyNowPayLaterMethod } from '@wix/cashier-core/dist/src/services/PaymentMethod/types';

export const sortPaymentMethodsByRank = (paymentMethods: BuyNowPayLaterMethod[]): BuyNowPayLaterMethod[] =>
  paymentMethods.sort((aMethod, bMethod) => aMethod.rank - bMethod.rank);
